<script setup lang="ts">
import { Notivue } from 'notivue';
import SuccessToast from './SuccessToast.vue';
import ErrorToast from './ErrorToast.vue';
import WarningToast from './WarningToast.vue';
import InfoToast from './InfoToast.vue';
import LoadingToast from './LoadingToast.vue';
</script>

<template>
  <Notivue v-slot="item">
    <LoadingToast v-if="item.type == 'promise'" :item="item" />
    <SuccessToast
      v-if="item.type == 'success' || item.type == 'promise-resolve'"
      :item="item"
    />
    <ErrorToast
      v-if="item.type == 'error' || item.type == 'promise-reject'"
      :item="item"
    />
    <WarningToast v-if="item.type == 'warning'" :item="item" />
    <InfoToast v-if="item.type == 'info'" :item="item" />
  </Notivue>
</template>

<style scoped></style>
